import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import useHomeViewsUserPreferencesQuery, {
	type useHomeViewsUserPreferencesQuery$data,
	type useHomeViewsUserPreferencesQuery$variables,
} from './__generated__/useHomeViewsUserPreferencesQuery.graphql.ts';

export const preloadOptions = ({ isLoggedIn }: { isLoggedIn: boolean }) => {
	if (!isLoggedIn) {
		return Promise.resolve({});
	}
	return query<useHomeViewsUserPreferencesQuery$data, useHomeViewsUserPreferencesQuery$variables>({
		query: useHomeViewsUserPreferencesQuery,
	});
};
